/**
 * Filter out third-party library deprecation and known benign noise from console.warn / console.error
 * (e.g. THREE.Clock deprecation inside @react-three/fiber & three-stdlib, React 19 defaultProps in R3F/Drei/postprocessing).
 */
if (typeof window !== 'undefined') {
  const IGNORED_WARNING_PATTERNS = [
    'THREE.Clock: This module has been deprecated',
    'Clock: This module has been deprecated',
    'THREE.ColorManagement: legacy mode is deprecated',
    'THREE.ColorManagement: .enabled is now enabled by default',
    'THREE.WebGLRenderer: The property .outputColorSpace has replaced .outputEncoding',
    'THREE.PropertyBinding: No target node found for track',
    'THREE.Quaternion: .inverse() has been renamed to .invert()',
    'defaultProps will be removed from function components',
    'Support for defaultProps will be removed',
    'THREE.Material: \'roughnessMap\' is not a valid property',
    'THREE.WARNING: Multiple instances of Three.js being imported',
    'Multiple instances of Three.js being imported',
    'target-position',
    'UNSAFE_componentWillReceiveProps',
    'UNSAFE_componentWillMount',
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded',
    'Added non-passive event listener',
    'THREE.MeshStandardMaterial: \'envMapIntensity\' is not a valid property',
    'WebGL context was lost',
    'WebGL: context lost',
    'THREE.WebGLState: WebGL context lost',
    'THREE.WebGLRenderer: Context Lost',
    'Prebuild 3D floor batches failed',
    'Error clearing legacy equipment storage',
  ];

  const formatArgs = (args: unknown[]): string => {
    return args
      .map((arg) => {
        if (typeof arg === 'string') return arg;
        if (arg instanceof Error) return arg.message + ' ' + (arg.stack ?? '');
        try {
          return JSON.stringify(arg);
        } catch {
          return String(arg);
        }
      })
      .join(' ');
  };

  const originalWarn = console.warn;
  console.warn = (...args: unknown[]) => {
    const text = formatArgs(args);
    if (IGNORED_WARNING_PATTERNS.some((pattern) => text.includes(pattern))) {
      return;
    }
    originalWarn.apply(console, args);
  };

  const originalError = console.error;
  console.error = (...args: unknown[]) => {
    const text = formatArgs(args);
    if (IGNORED_WARNING_PATTERNS.some((pattern) => text.includes(pattern))) {
      return;
    }
    originalError.apply(console, args);
  };
}

